import useParamSelector from '@/hooks/useParamSelector'
import { useTypedSelector } from '@/store/hooks'
import { isAppInstalled, isAuthorized } from '@/store/selectors'
import { Button, Tooltip } from '@livechat/design-system-react-components'

interface Props {
  id: string
  onClick: () => void
  onClose: () => void
}

const ReviewsFooter = ({ id, onClick, onClose }: Props) => {
  const isUserAuthorized = useTypedSelector(isAuthorized)
  const isInstalled = useParamSelector(isAppInstalled, id)
  const canVote = isUserAuthorized && isInstalled

  return (
    <>
      <Button onClick={onClose}>Cancel</Button>
      <Tooltip
        kind="invert"
        placement="top-end"
        triggerOnHover={!canVote}
        triggerRenderer={
          <Button kind="primary" onClick={onClick} disabled={!canVote}>
            Write a review
          </Button>
        }
      >
        Only app users can review it
      </Tooltip>
    </>
  )
}
export default ReviewsFooter
